/** Todo lo que ha pasado en el portal, en una lista. Es el registro de auditoría interno. */
import { useEffect, useState } from 'react'

import { ErrorDeApi, api } from '../api'
import { Cargando, Error, Vacio } from '../componentes/piezas'
import { usePortal } from '../contexto'
import { fechaYHora } from '../textos'
import type { LineaDeActividad } from '../tipos'

export default function Actividad() {
  const { ruta } = usePortal()
  const [lineas, setLineas] = useState<LineaDeActividad[] | null>(null)
  const [error, setError] = useState('')

  useEffect(() => {
    api
      .get<LineaDeActividad[]>(`${ruta}/actividad?limite=200`)
      .then(setLineas)
      .catch((e: ErrorDeApi) => setError(e.message))
  }, [ruta])

  return (
    <>
      <header className="cabecera">
        <h1>Actividad</h1>
      </header>
      <div className="contenido">
        {error && <Error>{error}</Error>}
        {!lineas && !error && <Cargando filas={6} />}
        {lineas && lineas.length === 0 && (
          <div className="tarjeta">
            <Vacio titulo="Todavía no ha pasado nada" />
          </div>
        )}
        {lineas && lineas.length > 0 && (
          <div className="tarjeta">
            <div className="tarjeta__cuerpo">
              <ul className="historial">
                {lineas.map((l) => (
                  <li key={l.id}>
                    {l.frase}
                    <time dateTime={l.cuando}>{fechaYHora(l.cuando)}</time>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        )}
      </div>
    </>
  )
}
